/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useAppDispatch} from "../../../../../redux/hooks";
import useGetUrlParams from "../../../../../hooks/useGetUrlParams";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../../constants";
import {usePostRequest} from "../../../../../api/helper";
import * as React from "react";
import {setDevelopmentStagesTree, setTriggerRefreshAfterNewAdasProgramAdded} from "../../../../../redux/ducks/VehicleProgramsDetails/slice";
import {toast} from "react-hot-toast";
import VAR_COMMON_CONSTANTS from "../../../../../constants/globalVariables";
import ArgosFlexbox from "../../../../components/Containers/ArgosFlexbox";
import ArgosDialog from "../../../../components/Dialogs/ArgosDialog";
import {MultiPageWizard} from "../../../../components/MultiPageWizard/MultiPageWizard";
import SelectAdasProgram from "./SelectAdasProgram";
import ReviewAdasSensors from "./ReviewAdasSensors";

const AddAdasProgramDialog = (props: any) => {
  const {open, onClose, data, setIsRightClickMenuOpen} = props
  const dispatch = useAppDispatch()

  const developmentStageId = data?.rightClickNodeData?.developmentStageId;
  const {vehicleProgramId} = useGetUrlParams()

  const urlAddAdasProgram = VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.addAdasProgramToDevStage
  const addAdasProgramHandle = usePostRequest(urlAddAdasProgram)

  const [wizardData, setWizardData] = React.useState<any>(null)

  const [selectedSensorPositionIds, setSelectedSensorPositionIds] = React.useState<Record<string, boolean>>({});

  const addAdasProgram = () => {
    const {adasProgramId} = wizardData
    toast.loading('Linking ADAS Program...', {id: 'linking-adas-program'})
    addAdasProgramHandle({
      vehicleProgramId,
      developmentStageId,
      adasProgramId,
      selectedSensorPositionIds
    }).then((res) => {
      const _tree = res?.tree
      if (_tree) {
        dispatch(setDevelopmentStagesTree(res.tree))
      }
      dispatch(setTriggerRefreshAfterNewAdasProgramAdded())
      onClose()
    }).catch((e) => {
      console.error(e)
      toast.error("Failed to link ADAS Program")
    }).finally(() => {
      toast.dismiss('linking-adas-program')
    })
  }

  const onWizardChange = (data: any) => {
    setWizardData((prevState: any) => {
      return {
        ...prevState,
        ...data
      }
    })
  }

  const steps = ['Configure properties', `Select ${VAR_COMMON_CONSTANTS.VAR_DATA_SET.toLowerCase()}s`]

  const [hasSensorMismatch, setHasSensorMismatch] = React.useState<boolean | null>(null)


  return (
    <ArgosFlexbox vertical style={{justifyContent: "center", alignItems: "center", overflow: 'auto', height: '100%'}}>
      <ArgosDialog
        width={'95vw'}
        height={'95vh'}
        open={open}
        headerTitle={`Link ADAS Program`}
        headerTitleAlign={'left'}
      >
        <MultiPageWizard steps={steps} onFinish={() => addAdasProgram()} onClickClose={() => props.onClose()}
                         isFinishDisabled={hasSensorMismatch === null
                           || selectedSensorPositionIds == null || Object.keys(selectedSensorPositionIds).length === 0
                         }
        >
          <ArgosFlexbox vertical style={{overflow: 'auto', height: '100%'}}>
            <SelectAdasProgram onChange={onWizardChange}/>
          </ArgosFlexbox>
          <ArgosFlexbox vertical style={{overflow: 'auto', height: '100%'}}>
            <ReviewAdasSensors
              selectedSensorPositionIds={selectedSensorPositionIds} setSelectedSensorPositionIds={setSelectedSensorPositionIds}
              developmentStageId={developmentStageId} adasProgramId={wizardData?.adasProgramId}
              setHasSensorMismatch={setHasSensorMismatch} hasSensorMismatch={hasSensorMismatch}
            />
          </ArgosFlexbox>
        </MultiPageWizard>
      </ArgosDialog>
    </ArgosFlexbox>
  )
}

export default AddAdasProgramDialog